import { Component, Input, ViewEncapsulation } from '@angular/core';
import Debug from 'debug';
const debug = Debug('aumico:aumico-lib-core-fe:AumBreadcrumbComponent');

export interface AumBreadcrumbComponentItem {
    displayName: string;
    isActive?: boolean;
    translated?: boolean;
    routerLink?: string;
    onClick?: () => void;
    [key: string]: unknown;
}

/*
usage
<aum-breadcrumb [items]=”items” />
*/

@Component({
    styleUrls: ['./breadcrumb.scss'],
    selector: 'aum-breadcrumb',
    host: {
        class: 'aum-breadcrumb',
    },
    encapsulation: ViewEncapsulation.None,
    template: `
        <span class="aum-breadcrumb-parent" *ngFor="let item of items; index as i; first as isFirst; last as isLast">
            <span
                (click)="itemClicked(item)"
                [routerLink]="item.routerLink"
                [ngClass]="{ 'aum-breadcrumb-active': item.isActive ? true : false }"
            >
                <span *ngIf="!item.translated">
                    {{ item.displayName | i18next }}
                </span>
                <span *ngIf="item.translated">
                    {{ item.displayName }}
                </span>
            </span>
            <span class="aumico-pattern-icon-arrow-right aumico-pattern-icon" *ngIf="!isLast">
                <i></i>
            </span>
        </span>
    `,
})
export class AumBreadcrumbComponent {
    @Input()
    public items: AumBreadcrumbComponentItem[] = [];

    public itemClicked(item: AumBreadcrumbComponentItem) {
        debug(item);
        debug('itemClicked');
        if (item.onClick) {
            item.onClick();
        } else {
            debug('item has no on click handler');
        }
    }
}
